import * as Yup from 'yup';

const zipCodeRegExp = /^[0-9]{5}(?:-[0-9]{4})?$/;
// const countryCodeRegExp = /^(\([2-9]{1}[0-9]{2}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/; // 0 and 1 is not allowed in phone

export const emptyValidationSchema = Yup.object({ });

export const registerCommonValidationSchema = Yup.object({
    subscriberEmail: Yup.string().required('Required').email('Email must be a valid email'),
    subscriberNameFirst: Yup.string().required('Required'),
    subscriberNameLast: Yup.string().required('Required'),
    address: Yup.string().required('Required'),
    city: Yup.string().required('Required'),
    state: Yup.string().required('Required'),
    zipCode: Yup.string()
        .required('Required')
        .matches(zipCodeRegExp, 'Please enter the valid 5-digit ZIP Code'),
    subscriberPhone: Yup.string()
        .required('Required')
        .min(14, "Phone Number is invalid"),
});

export const registerValidationSchema = registerCommonValidationSchema.shape({
    securityOverrideKeyword: Yup.string()
        .required('Required')
        .matches(
            /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
            "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character"
          ),
    securityOverrideKeyword2: Yup.string()
        .required('Required')
        .oneOf([Yup.ref('securityOverrideKeyword'), ""], 'Passwords must match'),
});

export const ForgotPasswordFormValidationSchema = Yup.object({
    subscriberEmail: Yup.string().required('Required').email('Email must be a valid email'),
});

export const updateShippingValidationSchema = Yup.object({
    shippingFirstName: Yup.string().required('Required').nullable(),
    shippingLastName: Yup.string().required('Required').nullable(),
    shippingAddress: Yup.string().required('Required').nullable(),
    shippingCity: Yup.string().required('Required').nullable(),
    shippingState: Yup.string().required('Required').nullable(),
    shippingZipcode: Yup.string()
        .required('Required')
        .matches(zipCodeRegExp, 'Zip Code is invalid')
        .nullable()
});

export const updateBillingValidationSchema = Yup.object({
    billingAddress: Yup.string().required('Required').nullable(),
    billingCity: Yup.string().required('Required').nullable(),
    billingState: Yup.string().required('Required').nullable(),
    billingZipcode: Yup.string()
        .required('Required')
        .matches(zipCodeRegExp, 'Zip Code is invalid')
        .nullable()
});

export const Step0FormValidationSchema = Yup.object({
    agreed1: Yup.boolean()
        .oneOf([true],'Required'),
    agreed2: Yup.boolean()
        .oneOf([true],'Required')
});

export const WorkdestFormValidationSchema = Yup.object({
    workdestCompany: Yup.string().required('Required'),
    workdestAddress: Yup.string().required('Required'),
    workdestCity: Yup.string().required('Required'),
    workdestZipcode: Yup.string()
        .required('Required')
        .matches(zipCodeRegExp, 'Zip Code is invalid'),
    workdestPhone: Yup.string()
        .required('Required')
        .min(14, "Phone Number is invalid"),
});

export const VehicleFormValidationSchema = Yup.object({
    make: Yup.string().required('Required'),
    model: Yup.string()
        .required('Required'),
    year: Yup.number()
        .required('Required')
        .min(1900, 'Invalid year')
        .max(new Date().getFullYear() + 1, 'Invalid year'),
    licensePlateNbr: Yup.string()
        .required('Required')
        .max(10, "License Plate should be 10 or less than 10 characters"),
});

export const VanpoolVehicleFormValidationSchema = VehicleFormValidationSchema.shape({
    transitAgency: Yup.string()
        .required('Required'),
});

export const RiderFormValidationSchema = Yup.object({
    firstName: Yup.string().required('Required'),
    lastName: Yup.string().required('Required'),
    address: Yup.string().required('Required'),
    city: Yup.string().required('Required'),
    zipcode: Yup.string()
        .required('Required')
        .matches(zipCodeRegExp, 'Zip Code is invalid'),
    phone: Yup.string()
        .required('Required')
        .min(14, "Phone Number is invalid"),
    // employer
    employerName: Yup.string().required('Required'),
    employerCity: Yup.string().required('Required'),
    employerZipcode: Yup.string()
        .required('Required')
        .matches(zipCodeRegExp, 'Zip Code is invalid'),
});

export const reportUserValidationSchema = Yup.object({
    reason: Yup.string().required('Required'),
    message: Yup.string()
        .required('Required')
        .max(1000, "Message meet the maximum character limitation"),
    agree: Yup.boolean()
        .oneOf([true],'Required')
});